/**
*
* Header
*
*/

import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { Alert, Card } from 'react-bootstrap';
import Search from 'components/interaction/Search/index.jsx';
import IconButton from 'components/interaction/IconButton/index.jsx';
import { useSearch } from 'utils/urlUtils.js';
import Icon2 from 'components/media/Icon2/index.js';
import messages from '../messages.js';
import { MIN_SEARCH_LENGTH } from '../constants.jsx';

const Feedback = styled(Alert)`
  position: absolute;
  right: 0;
  z-index: 1;
`;

function Header() {
  const { q, replace } = useSearch();
  const navigate = useNavigate();
  const { inboxId } = useParams();
  const [showSearch, setShowSearch] = useState(Boolean(q));
  const [hasError, setHasError] = useState(false);
  function handleSearchChange(value) {
    const error = value.length > 0 && value.length < MIN_SEARCH_LENGTH;
    setHasError(error);
    if (!error) {
      if (q) {
        replace('q', value);
      } else {
        navigate(`/conversations/inboxes/${inboxId}?q=${value}`);
      }
    }
  }

  return (
    <Card.Header className="d-flex justify-content-between align-items-baseline border-bottom-0 pb-0">
      <h2 className="card-title">
        <FormattedMessage {...messages.conversations} />
      </h2>
      {showSearch
        ? (
          <div className="position-relative ms-5 d-print-none">
            <Search
              className="form-control"
              hasError={hasError}
              onChange={handleSearchChange}
              minLength={MIN_SEARCH_LENGTH}
              autoFocus
              onCancel={() => setShowSearch(false)}
              value={q?.toString()}
              delay={1000}
            />
            {hasError && (
              <Feedback variant="danger" className="p-1 mt-2 w-100 text-center">
                <FormattedMessage {...messages.searchMinLength} values={{ min: MIN_SEARCH_LENGTH }} />
              </Feedback>
            )}
          </div>
        )
        : (
          <div className="d-print-none d-flex">
            <Link to={`/conversations/inboxes/${inboxId}/archive`} className="p-2">
              <Icon2 className="ss-archive fs-4" />
            </Link>
            <IconButton icon="ss-search fs-3" onClick={() => setShowSearch(true)} variant="link" className="py-2" />
          </div>
        )}
    </Card.Header>
  );
}

export default Header;
